import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';
import { NavigationService } from 'src/app/navigation/service/navigation.service';

@Component({
    selector: 'app-chart-kpi-stacked-column',
    imports: [CommonModule, HighchartsChartModule],
    templateUrl: './chart-kpi-stacked-column.component.html',
    styleUrl: './chart-kpi-stacked-column.component.scss'
})
export class ChartKpiStackedColumnComponent
  implements OnChanges, OnInit, OnDestroy
{
  @Input() hc: any = {};
  @Input() chartData: any;
  @Input() showFilter: boolean = false;
  @Input() filterType: string = '';
  @Input() pointWidth: number = 20;
  @Input() chartWidth: number = 0;
  @Input() filterFrom: string = '';

  columnchart: any;

  public navService = inject(NavigationService);

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    this.columnchart = this.buildChart();
  }

  ngOnInit(): void {}

  buildChart() {
    const chartData = this.chartData;

    if (!chartData) {
      return;
    }
    const categories = chartData.labels.map((label: any) => label);
    const data = chartData.data.map((data: any) => data);
    const yAxisLabelsFormat = data[0].name === 'Exit' ? '{value:.0f}' : '';

    return {
      chart: {
        type: 'column',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories,
        crosshair: true,
        lineColor: '#545454B8',
        labels: {
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      yAxis: {
        lineWidth: 1,
        tickAmount: 6,
        gridLineWidth: 0,
        title: '',
        lineColor: '#545454B8',
        stackLabels: {
          enabled: true,
        },
        labels: {
          format: yAxisLabelsFormat,
          style: {
            color: '#545454B8',
            fontWeight: '600',
            fontSize: '10px',
            fontFamily: 'Nunito',
          },
        },
      },
      plotOptions: {
        dataLabels: {
          enabled: true,
        },
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: false,
          },
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        symbolRadius: 0,
        itemStyle: {
          fontFamily: 'Nunito',
          fontWeight: 600,
        },
      },
      series: data,
      // to make sure the graph is responsive at all break-points
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500,
            },
            chartOptions: {
              yAxis: {
                labels: {
                  align: 'left',
                  x: 0,
                  y: -2,
                },
                title: {
                  text: '',
                },
              },
            },
          },
        ],
      },
    };
  }

  ngOnDestroy(): void {}
}
